import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { VoucherService } from '../../../services/voucher-service';

/*
 * Merge Well Dialog
 */
@Component({
    selector: 'dialog-application-edit',
    templateUrl: 'application-edit-dialog.html'
  })
  export class DialogEditApplicationComponent implements OnInit  {
    loading: boolean = false;
    applicationId: number = 0;
    
    constructor(public oregonWellDataService: OregonWellDataService, 
                public voucherService: VoucherService, 
                private toastr: ToastrService, 
                @Inject(MAT_DIALOG_DATA) public data: number,
                private dialogRef: MatDialogRef<DialogEditApplicationComponent>) {
                  this.loading = true;
                  this.applicationId = this.data;
                  this.loading = false;

    }

    ngOnInit(): void {
      // ngOnInit       
    }
  }